export default class LieuFormNiveauxController {
    static $inject = ['LieuxService', 'notification'];

    constructor(LieuxService, notification) {
        this.LieuxService = LieuxService;
        this.notification = notification;
    }

    $onInit() {
        // Propriétés
        this.loading = true;
        this.lieu = this.lieu || {};
        this.values = angular.copy(this.lieu.niveaux);
        this.niveaux = this.niveaux || [];
        this.elements = this.elements || [];
    }

    $onChanges(objChanges) {
        if (objChanges.lieu) {
            this.loadNiveaux();
        }
    }

    $doCheck() {
        if (!angular.equals(this.values, this.lieu.niveaux)) {
            this.onUpdate({
                niveaux: angular.copy(this.values)
            });
        }
    }

    async loadNiveaux() {
        this.startLoading();

        try {
            this.niveaux = await this.LieuxService.getLieuxNiveaux();
            this.elements = await this.LieuxService.getLieuxElements();
        } catch (ex) {
            this.notification.error(ex);
        } finally {
            this.stopLoading();
        }
    }

    startLoading() {
        this.loading = true;
    }

    stopLoading() {
        this.loading = false;
    }
}
